export enum AccountTypeFeePeriod {
  Monthly = 'MONTHLY',
  Withdraw = 'WITHDRAW',
  Conditional = 'CONDITIONAL',
}

export enum CaymanAccountTypeName {
  Chequing = 'Chequing',
  EZBanking = 'EZ Banking',
  Caymanite = 'Caymanite',
  GenNow = 'GenNow',
}
